<template>
    <div>
        <action-bar>
            <router-link :to="{name: 'result-create'}">Neues Resultat erstellen</router-link>
        </action-bar>
        <main class="content">
            <h1>Resultate</h1>
            <table class="table table-striped" v-if="results">
                <thead>
                <tr>
                    <th>Title</th>
                    <th>Klasse</th>
                    <th>Bild</th>
                    <th>Version</th>
                    <th class="text-right">Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="result in results" :key="result.id">
                    <td>{{result.name.text}}</td>
                    <td>{{result.class}}</td>
                    <td>{{(result.image && result.image.urls) ? 'Ja' : 'Nein'}}</td>
                    <td>{{result.editVersion}}</td>
                    <td class="text-right">
                        <a href="#" v-confirm="{
                            html: true,
                            ok: dialog => remove(dialog, result),
                            message: 'Bist du sicher, dass du das Resultat <strong>'+result.name.text+'</strong> löschen möchtest?'}"><i
                                class="fa fa-trash fa-fw"></i></a>
                        <router-link :to="{name: 'result-edit', params: {resultId: result.id}}"><i class="fa fa-edit fa-fw"></i>
                        </router-link>
                    </td>
                </tr>
                </tbody>
            </table>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
export default {
    methods: {
        remove(dialog, result) {
            this.results.splice(this.results.indexOf(result), 1);
            axios.post("/api/" + store.state.language + "/result/" + result.id + "/delete");
        }
    },
  asyncComputed: {
    results() {
      let test = store.state.language;
      return axios
        .get("/api/" + store.state.language + "/result/list")
        .then(({ data }) => data.result);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/result/GeneralList.vue